import { formsData, formsData072026 } from "../data/formsData";
import { getIsNewBusinessRulesEffective } from "./useEffectiveDate";

export function getActiveFormsData(effectiveDate?: string) {
  return getIsNewBusinessRulesEffective(effectiveDate) ? formsData072026 : formsData;
}

export function useFormsData(effectiveDate?: string) {
  return { formsData: getActiveFormsData(effectiveDate) };
}
